import PropTypes from 'prop-types';
import { Link as MuiLink } from '@mui/material';

const Link = ({ children, ...props }) => (
  <MuiLink
    {...props}
    underline="none"
    sx={({ palette }) => ({
      color: palette.primary.main,
    })}
  >
    {children}
  </MuiLink>
);

Link.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Link;
